import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["animation", "className"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import classnames from 'classnames';
import { ROOT_PREFIX, skeletonTheme } from './skeletonStyles';
export var EmbersSkeleton = function EmbersSkeleton(_ref) {
  var animation = _ref.animation,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: skeletonTheme
  }, /*#__PURE__*/React.createElement(Skeleton, _extends({}, props, {
    className: classnames(["".concat(ROOT_PREFIX, "-root")], _defineProperty({}, "".concat(ROOT_PREFIX, "-animation-progress"), animation === 'progress'), className),
    animation: animation !== 'progress' ? animation : false
  })));
};